import { useEffect } from "react";
import { MapRef, useMap } from "react-map-gl/maplibre";

type Props = {
  setMap: (map: MapRef) => void;
};

// Some logic to refer the map back to the mainmap to be able to set the hover
const SetMap: React.FC<Props> = ({ setMap }) => {
  const map = useMap().current;
  useEffect(() => {
    if (map) setMap(map);
  }, [map, setMap]);
  return null;
};

export { SetMap };
